import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconBubbleWide: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-outlined-radius-0-stroke-1-IconBubbleWide"><Path d="M2.5 3.5L21.5 3.50002V18.5H15.0155L11.9979 21L9.0155 18.5L2.5 18.5V3.5Z" stroke="currentColor"/></CentralIconBase>;
});

export default IconBubbleWide;
